import React from "react";
import { useMediaQuery } from "react-responsive";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";

function OpportunitiesDesktop({ app, config }) {
  const notFullHd = useMediaQuery({ query: "(max-width: 1536px)" });

  return (
    <div className="app opportunities">
      <div className="appContent">
        <Grid container flexDirection={"column"}>
          <Grid item>
            <LayoutWrapper>
              <Card
                app={app}
                header={{
                  hardTitle: "Apuração por Grupo Produto",
                }}
                exportTable
                exportContainer
                exportTableId="9ad5c52a-6b32-47bd-93c9-bcc43654dadf"
                style={{ width: "100%", height: "100%" }}
                className={"container-table"}
              >
                <div className="container-maps-graphs">
                  <NativeObject
                    app={app}
                    key="9ad5c52a-6b32-47bd-93c9-bcc43654dadf"
                    reference={{ id: "9ad5c52a-6b32-47bd-93c9-bcc43654dadf" }}
                    style={{ width: "60%", height: "331px" }}
                  />

                  <NativeObject
                    app={app}
                    key="JCJmNj"
                    reference={{ id: "JCJmNj" }}
                    style={{ width: "50%", height: "280px" }}
                  />

                  <NativeObject
                    app={app}
                    key="bHMmSA"
                    reference={{ id: "bHMmSA" }}
                    style={{ width: "20%", height: "286px" }}
                  />
                </div>
              </Card>
            </LayoutWrapper>
          </Grid>

          <Grid item>
            <LayoutWrapper>
              <Card
                app={app}
                exportTable
                exportContainer
                exportTableId="JJSTVp"
                header={{
                  hardTitle: "Positivação por distribuidores",
                }}
                style={{ width: "100%", height: "100%" }}
                className={"container-table"}
              >
                <div className="container-maps-graphs">
                  <NativeObject
                    app={app}
                    key="JJSTVp"
                    reference={{ id: "JJSTVp" }}
                    style={{ width: "40%", height: "358px" }}
                  />

                  <NativeObject
                    app={app}
                    key="Phrzptj"
                    reference={{ id: "Phrzptj" }}
                    style={{ width: "60%", height: "362px" }}
                  />
                </div>
              </Card>
            </LayoutWrapper>
          </Grid>

          <Grid item>
            <LayoutWrapper>
              <Card
                app={app}
                exportTable
                exportContainer
                exportTableId="dzgRmP"
                header={{
                  hardTitle: "Evolução anual",
                }}
                style={{ width: "100%", height: "100%" }}
                className={"container-table"}
              >
                <NativeObject
                  app={app}
                  key="Xjbf"
                  reference={{ id: "Xjbf" }}
                  style={{ height: "358px" }}
                />
              </Card>
            </LayoutWrapper>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

OpportunitiesDesktop.defaultProps = {
  app: null,
  config: {},
};

OpportunitiesDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default OpportunitiesDesktop;
